import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { DataView } from 'primereact/dataview';
import { Message } from 'primereact/message';
import { useState } from 'react';
import Data from '../../../../components/Display/Data';
import DataTag from '../../../../components/Display/DataTag';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import { getConstant } from '../../../../utils/constants';
import ImageItem from '../../common/image/ImageItem';
import DistributionItem from '../distribution/DistributionItem';
import NewsListItem from '../news/NewsListItem';
import styles from "../../../../components/Display/Wrapper.module.scss";

const ASPECT_RATIO = 1;

function ResourceDetail({
  resource,
  handleUpdateResource,
  handleUpdateDistribution,
  handleUpdateDistributionList,
  handleDeleteDistribution,
  handleDelete,
  handleCreateNews,
  handleUpdateNews,
  handleDeleteNews
}) {
  const [imageisValid, setImageisValid] = useState(true);

  const updateResourceActions = [
    {
      onClick: handleUpdateResource,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const newDistribActions = [
    {
      onClick: handleUpdateDistributionList,
      label: 'Modifier la distribution',
      icon: 'pi-pencil'
    }
  ];

  const newNewsActions = [
    {
      onClick: handleCreateNews,
      label: 'Ajouter un article',
      icon: 'pi-plus'
    }
  ];

  // Image is valid if width == height
  const computeImageShape = (img) => {
    setImageisValid(
      img.nativeEvent.srcElement.naturalHeight === img.nativeEvent.srcElement.naturalWidth
    );
  };

  const confirmDeletion = (resource) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce Disque ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(resource)
    });
  };

  const confirmNewsDeletion = (news) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cet article ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteNews(news)
    });
  };

  const newsItemTemplate = (news) => {
    return (
      <NewsListItem news={news} deleteNews={confirmNewsDeletion} updateNews={handleUpdateNews} />
    );
  };

  return (
    <div className={styles.scrollableSectionContainer}>
      <Section label="Informations Générales" actions={updateResourceActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={resource.title} large />
          <DataTag
            key="type"
            label={'Type'}
            tag={getConstant('melismes.resourceTypes', resource.type)}
            large
            rounded
          />
          <DataTag
            key="status"
            label="État"
            tag={getConstant('melismes.common.statusTypes', resource.status)}
            rounded
            large
          />
          <DataTag
            key="program"
            label="Programme lié"
            tag={{
              label: resource.program?.title,
              bgColor: 'bg-slate-700',
              icon: 'program'
            }}
            large
          />
          <Data key="deezer_id" label={'Id Deezer'} value={resource.deezer_id} large />
          <Data key="video_url" label={'URL Youtube'} value={resource.video_url} large />
          <Data key="buy_url" label={"URL d'achat"} value={resource.buy_url} large />
        </div>
        <div className="flex flex-wrap gap-5">
          <MultiLineData
            key="description"
            label={'Description'}
            value={resource.description}
            large
            asHtml
          />
        </div>
      </Section>
      <Section label="Image principale">
        {!imageisValid && resource.main_image && (
          <div>
            <Message
              severity="warn"
              text={`Cette image n'est pas au ratio ${ASPECT_RATIO}:1, l'affichage sur le site ne sera pas optimal.`}
            />
          </div>
        )}
        <ImageItem image={resource.main_image} imageLoad={computeImageShape} className="w-96" />
      </Section>
      <Section label="Distribution" actions={newDistribActions}>
        {resource?.distributions?.length > 0 ? (
          <div className="flex flex-wrap gap-3">
            {resource.distributions.map((distrib) => (
              <DistributionItem
                distribution={distrib}
                key={distrib.id}
                handleUpdateDistribution={() => handleUpdateDistribution(distrib)}
                handleDeleteDistribution={() => handleDeleteDistribution(distrib)}
              />
            ))}
          </div>
        ) : (
          <p className="italic text-slate-400 font-light">Non renseignée</p>
        )}
      </Section>

      <Section label="Articles de presse" actions={newNewsActions}>
        <DataView
          value={resource.news}
          itemTemplate={newsItemTemplate}
          emptyMessage="Aucun article à afficher"
        />
      </Section>

      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={'Supprimer la ressource'}
            className="w-54"
            outlined
            onClick={() => confirmDeletion(resource)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default ResourceDetail;
